import { State } from "@/state";
import { useLayoutEffect } from "react";
import { PanelLeftOpenIcon } from "lucide-react";

export const COMMAND_ID = "toggle-sidebar-visibility";

export type ToggleSidebarVisibilityContextType = Record<string, never>;

export function ToggleSidebarVisibilityCommand() {
  const registerCommandDefinition = State(
    (state) => state.registerCommandDefinition,
  );
  const unregisterCommandDefinition = State(
    (state) => state.unregisterCommandDefinition,
  );

  useLayoutEffect(() => {
    registerCommandDefinition({
      id: COMMAND_ID,
      title: "Toggle Sidebar",
      getTitle: () =>
        State.getState().isSidebarMinimized ? "Show Sidebar" : "Hide Sidebar",
      description: "Toggle the sidebar visibility",
      onClick: () => {
        const current = State.getState().isSidebarMinimized;
        State.getState().setIsSidebarMinimized(!current);
        State.getState().clearCommandStack();
      },
      ReactIcon: PanelLeftOpenIcon,
      group: "Appearance",
    });

    return () => {
      unregisterCommandDefinition(COMMAND_ID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
